var React = require("react");

var ApplicationContext = require("../../config/ApplicationContext.js");

class ErrorMessage extends React.Component {
    render() {
        let { 
            title, 
            failMessage, 
            helpMessage, 
            serverMessage,
            CustomOptions = () => null,
            onClose 
        } = this.props;

        return (
            <div className="error">
                <img className="error__icon" src={`${ApplicationContext.assetUrlPrefix}/assets/icons/error.svg`}/>
                <h2 className="error__title" dangerouslySetInnerHTML={{__html: title}}></h2>
                <p className="error__message">{ failMessage }</p>
                <p className="error__message">{ helpMessage }</p>
                <p className="error__message">{ serverMessage }</p>
                <CustomOptions/>
                <button className="button btnClose" onClick={onClose}>Close</button>
            </div>
        );
    }
};

module.exports = ErrorMessage;